import { cn } from '@bem-react/classname';
import Section from 'components/Section';
import TitleBase, { withLevel2 } from 'components/Title'
import { compose } from '@bem-react/core'
import { fetchGroups, selectTeacherJournal } from 'modules/TeacherJournal';
import React, { FC } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useConstructor } from 'utils';
import '../TeacherTest/TeacherTest.scss'
import Journal from './Journal/Journal';
import PortalList from './PortalList/PortalList';
import BreadcrumbTeacher from 'pages/TeacherPage/BreadcrumbTeacher/BreadcrumbTeacher';


const Title = compose(withLevel2)(TitleBase)

const TeacherJournal: FC = () => {
  
  const dispatch = useDispatch()
    useConstructor(() => {
      if (!window.hasOwnProperty('jQuery')){
        const jquery = document.createElement('script')
        jquery.src = '/js/jquery.min.js'
        document.head.appendChild(jquery)  
      }
      if (!window.jQuery.fn.hasOwnProperty('dialog')){
        const jqui = document.createElement('script')
        jqui.src = '/js/jquery-ui.js'
        document.head.appendChild(jqui)
        const jquicss = document.createElement('link')
        jquicss.rel  = 'stylesheet';
        jquicss.type = 'text/css';
        jquicss.href = '/js/jquery-ui.min.css';
        jquicss.media = 'all';
        document.head.appendChild(jquicss)
      }
  
      if (!window.jQuery.fn.hasOwnProperty('timepicker')){
        const jqui = document.createElement('script')
        jqui.src = '/js/timepicker/jquery.ui.timepicker.js'
        document.head.appendChild(jqui)
        const jquicss = document.createElement('link')
        jquicss.rel  = 'stylesheet';
        jquicss.type = 'text/css';
        jquicss.href = '/js/timepicker/jquery.ui.timepicker.css';
        jquicss.media = 'all';
        document.head.appendChild(jquicss)
      }
  
      if (!window.hasOwnProperty('test_properties')){
        const tp = document.createElement('script')
        tp.src = '/js/test_properties.js'
        document.head.appendChild(tp)
      }
      dispatch(fetchGroups())
    });
    const cnTeacherPupil = cn('TeacherTest')
    
    const data = useSelector(selectTeacherJournal)

    return (
        <Section className={cnTeacherPupil()}>
          <Title level="2">Учителю</Title>
        <BreadcrumbTeacher/>
        <div >
        <span style={{float:'right'}}><a href="/teacher?a=journal">Старый журнал</a></span><br/>
        </div>
        {data.error?<span>{data.error}</span>:<>
            <PortalList/>
            <Journal/>
            </>}
        </Section>
    )
  }


export default TeacherJournal